import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Routes, RouterModule } from '@angular/router';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { IonicModule } from '@ionic/angular/lazy';
import { ParkedCartEditPage } from 'src/app/modals/parked-cart-edit/parked-cart-edit.page';

const routes: Routes = [
    {
        path: '',
        component: ParkedCartEditPage
    }
];

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        IonicModule,
        FontAwesomeModule,
        RouterModule.forChild(routes)
    ],
    declarations: [ParkedCartEditPage]
})

export class ParkedCartEditPageModule { }
